import React, { useState } from "react";

import { ArrowForward } from "@mui/icons-material";
import {
  Box,
  Card,
  Dialog,
  List,
  ListItem,
  Typography,
  Grid,
} from "@mui/material";
// import { Unstable_Grid2 as Grid2 } from "@mui/material";
import ReactCardFlip from "react-card-flip";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CampaignIcon from "../../assets/images/Dashbaord/2.webp";
import DownloadIcon from "../../assets/images/Dashbaord/3.webp";
import SettingsIcon from "../../assets/images/Dashbaord/5.webp";
// Update with actual path to Image 1
import RibbenImg from "../../assets/images/ribben.png";
import { updateUser as updateUserAction } from "../../redux/slices/authSlice";
// import { TryNowButton } from "../Dashboard/DashboardFeatureLinks";

const SelectFlowModal = ({ open, firstName, onClose, updateUser }) => {
  const navigate = useNavigate();
  const [flippedCard, setFlippedCard] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleMouseEnter = (title) => {
    if (flippedCard !== title) {
      setFlippedCard(title); // Flip only if not already flipped
    }
  };

  const handleMouseLeave = (flag) => {
    if (flag) {
      if (flippedCard !== hoveredCard) {
        setFlippedCard(null); // Flip back when mouse leaves
      }
    } else {
      setFlippedCard(null); // Flip back when mouse leaves
    }
  };

  const handleClose = () => {
    onClose();
    updateUser({ is_initial_login: false });
  };

  const processes = [
    // {
    //   icon: (
    //     <Box
    //       component="img"
    //       src={SearchIcon}
    //       height={{ xs: "50px", lg: "70px" }}
    //       width={{ xs: "50px", lg: "90px" }}
    //     />
    //   ),
    //   title: "Find Perfect Match",
    //   description: "Find Perfect Match",
    //   onClick: () => null,
    //   isComingSoon: true,
    // },
    {
      icon: (
        <Box
          component="img"
          src={CampaignIcon}
          height={{ xs: "50px", lg: "70px" }}
          width={{ xs: "60px", lg: "70px" }}
        />
      ),
      title: "Post a Job in 5 Minutes",
      description:
        "Set up and post your job to instantly receive top-qualified candidates.",
      onClick: () => {
        navigate("/posts/create/flow/1");
        handleClose();
      },
      isComingSoon: false,
      whenToUse: [
        "Launching urgent hiring for new roles.",
        "Expanding teams or replacing outgoing talent quickly.",
      ],
      whatToExpect: [
        "Immediate visibility on job boards and social platforms.",
        "A surge of pre-vetted, qualified applicants within hours.",
      ],
    },
    {
      icon: (
        <Box
          component="img"
          src={DownloadIcon}
          height={{ xs: "50px", lg: "60px" }}
          width={{ xs: "50px", lg: "60px" }}
        />
      ),
      title: "Import Candidates",
      description:
        "Import existing candidate data in bulk to analyze and filter for the right fits.",
      onClick: () => {
        navigate("/bulk-upload");
        handleClose();
      },
      isComingSoon: false,
      whenToUse: [
        "When you have the candidate data and you have to manually screen them",
        "Migrating from legacy systems or external databases.",
      ],
      whatToExpect: [
        "Unified candidate profiles for easy comparison.",
        "AI-powered filters to shortlist candidates by role, experience, or skills.",
      ],
    },
    // {
    //   icon: (
    //     <Box
    //       component="img"
    //       src={AssignmentIcon}
    //       height={{ xs: "50px", lg: "60px" }}
    //       width={{ xs: "50px", lg: "60px" }}
    //     />
    //   ),
    //   title: "Conduct Assessment",
    //   description: "Create or send assessments to evaluate candidates' skills.",
    //   onClick: () => {
    //     navigate("/assessments");
    //     handleClose();
    //   },
    //   isComingSoon: false,
    //   whenToUse: [
    //     "To make sure that candidate have the required expertise claimed in resume.",
    //     "Screening candidates for technical/role-specific expertise.",
    //   ],
    //   whatToExpect: [
    //     "Detailed skill reports with scores and benchmarks.",
    //     "Automated ranking of top performers for faster decision-making.",
    //   ],
    // },
    {
      icon: (
        <Box
          component="img"
          src={SettingsIcon}
          height={{ xs: "50px", lg: "60px" }}
          width={{ xs: "50px", lg: "60px" }}
        />
      ),
      title: "Build Recruitment Pipeline",
      description:
        "AI handles hiring—posting, screening, assessing, and selecting the top 1%.",
      isComingSoon: false,
      whenToUse: [
        "Scaling recruitment without expanding HR teams.",
        "Prioritizing efficiency in high-volume hiring cycles.",
      ],
      whatToExpect: [
        "End-to-end automation: job postings, screening, and assessments.",
        "A curated shortlist of the top 1% talent, ready for final interviews.",
      ],

      onClick: () => {
        navigate("/posts/create/flow/4");
        handleClose();
      },
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          margin: 0,
          // height: "90vh",
          maxWidth: "none",
          maxHeight: "90vh", // Ensures it respects viewport height
          p: { xs: 3, md: 6 },
          borderRadius: "10px",
          width: { xs: "95vw", lg: "68vw" },
          overflow: "auto", // Enables modal scrolling
          backgroundImage: `url(${RibbenImg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start", // Adjust to avoid overflow issues
          paddingBottom: 2,
          position: "relative", // Add this to position the rectangle
        },
      }}
    >
      <Typography color="#5E7A7D" fontSize="35px" fontWeight={600}>
        Welcome, {firstName}!
      </Typography>
      <Typography
        fontFamily="Outfit"
        fontSize="18px"
        color="#5E7A7DB2"
        textAlign="center"
      >
        Getgeek is excited to introduce you to our top features.
      </Typography>

      <Grid
        container
        alignItems="center"
        justifyContent="center"
        sx={{ mt: 5, mx: { xs: 0, lg: 10 } }}
        spacing={2}
      >
        {processes?.map((process, index) => {
          // if (index === 0) {
          //   return (
          //     <Grid2
          //       key={process?.title}
          //       size={{ xs: 12, sm: 8, md: 6, lg: 4 }}
          //       className="center"
          //     >
          //       <Card sx={cardStyles}>
          //         {process.icon}
          //         <Box>
          //           <Typography
          //             gutterBottom
          //             sx={{
          //               fontSize: { xs: "14px", lg: "16px" },
          //               fontWeight: 600,
          //               textAlign: "center",
          //               color: "black",
          //             }}
          //           >
          //             {process.title}
          //           </Typography>
          //           <Typography
          //             color="text.secondary"
          //             sx={{
          //               fontSize: { xs: "10px", lg: "14px" },
          //               mb: { xs: 1, lg: 3 },
          //               textAlign: "center",
          //               color: "#989393E5",
          //             }}
          //           >
          //             {process.description}
          //           </Typography>
          //         </Box>
          //         <Box>
          //           <Button
          //             fullWidth
          //             variant="main"
          //             sx={{
          //               pointerEvents: "none",
          //               bgcolor: "purple.main",
          //               py: { xs: "3px", lg: "8px" },
          //             }}
          //           >
          //             Coming soon
          //           </Button>
          //         </Box>
          //       </Card>
          //     </Grid2>
          //   );
          // }

          return (
            <Grid
              key={process?.title}
              size={{ xs: 12, sm: 8, md: 6, lg: 4 }}
              className="center"
            >
              <ReactCardFlip
                isFlipped={flippedCard === process?.title}
                containerStyle={{ width: "100%" }}
                flipDirection="horizontal"
              >
                <Card
                  sx={{ ...cardStyles, gap: 2 }}
                  onMouseEnter={() => {
                    setHoveredCard(process.title);
                    handleMouseEnter(process?.title);
                  }} // Flip when entering
                  onMouseLeave={() => handleMouseLeave(true)} // Flip back when leaving
                >
                  {process.icon}
                  <Box>
                    <Typography
                      gutterBottom
                      sx={{
                        fontSize: { xs: "14px", lg: "16px" },
                        fontWeight: 600,
                        textAlign: "center",
                        color: "black",
                      }}
                    >
                      {process.title}
                    </Typography>
                    <Typography
                      color="text.secondary"
                      sx={{
                        fontSize: { xs: "10px", lg: "14px" },
                        mb: { xs: 1, lg: 3 },
                        textAlign: "center",
                        color: "#989393E5",
                      }}
                    >
                      {process.description}
                    </Typography>
                  </Box>
                </Card>

                <Card
                  sx={{
                    ...cardStyles,
                    alignItems: "flex-start",
                    bgcolor: "primary.main",
                    overflow: "auto",
                  }}
                  onMouseEnter={() => handleMouseEnter(process?.title)} // Prevent unnecessary flipping
                  onMouseLeave={() => {
                    handleMouseLeave(false);
                  }} // Flip back when leaving
                >
                  <Typography color="white" fontSize="14px" fontWeight={700}>
                    When to use
                  </Typography>
                  <List sx={{ pl: 3, listStyleType: "disc", py: 0 }}>
                    {process.whenToUse.map((item, i) => (
                      <ListItem
                        key={i}
                        sx={{
                          color: "white",
                          py: 0.5,
                          fontSize: "12px",
                          display: "list-item",
                        }}
                      >
                        {item}
                      </ListItem>
                    ))}
                  </List>

                  <Typography color="white" fontSize="14px" fontWeight={700}>
                    What to expect
                  </Typography>
                  <List sx={{ pl: 3, listStyleType: "disc", py: 0 }}>
                    {process.whatToExpect.map((item, i) => (
                      <ListItem
                        key={i}
                        sx={{
                          color: "white",
                          py: 0.5,
                          fontSize: "12px",
                          display: "list-item",
                        }}
                      >
                        {item}
                      </ListItem>
                    ))}
                  </List>
                </Card>
              </ReactCardFlip>
            </Grid>
          );
        })}
      </Grid>
    </Dialog>
  );
};

const cardStyles = {
  boxShadow: "0px 15px 20px 0px #0000000D",
  height: { xs: "250px", md: "300px" },
  border: "1px solid #EEEEEE",
  width: "90%",
  flexDirection: "column",
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  p: 2,
};

const mapStateToProps = (state) => ({
  firstName: state.auth?.user?.personal_information?.first_name,
});

const mapDispatchToProps = {
  updateUser: updateUserAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectFlowModal);
